import {
  type CreatePayment,
  type ListPaymentsQuery,
  type PaymentListResponse,
  PaymentListResponseSchema,
  type PaymentResponse,
  PaymentResponseSchema,
} from '@monorepo/shared/schemas/payments'
import { get, post } from '@/lib/api-client'

export const paymentsService = {
  async listPayments(
    params?: Partial<ListPaymentsQuery>
  ): Promise<PaymentListResponse> {
    const searchParams = new URLSearchParams()
    // Always expand customer data for the list view
    searchParams.set('expand', 'customer')

    if (params) {
      for (const [key, value] of Object.entries(params)) {
        if (value !== undefined && value !== null && value !== '') {
          searchParams.set(key, String(value))
        }
      }
    }

    return get(
      `/payments?${searchParams.toString()}`,
      PaymentListResponseSchema
    )
  },

  async createPayment(data: CreatePayment): Promise<PaymentResponse> {
    return post('/payments', data, PaymentResponseSchema)
  },
}
